export const DESKTOP_BREAKPOINT = "1200px";
export const DESKTOP_MEDIA_QUERY = `(min-width: ${DESKTOP_BREAKPOINT})`;

export const MOBILE_BREAKPOINT = "600px";
export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_BREAKPOINT})`;
